import { authedJson } from '../api/client';

export interface Team {
  teamId: string;
  workspaceId: string;
  name: string;
  description: string;
  createdBy: string;
  createdAt: number;
  updatedAt: number;
}

export interface TeamMemberInfo {
  userId: string;
  email: string;
  displayName: string;
  addedAt: number;
}

export interface GetTeamResponse {
  team: Team;
  members: TeamMemberInfo[];
}

type GetToken = () => string | null;
type DoRefresh = () => Promise<boolean>;

export const teamsApi = {
  list: (workspaceId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<{ teams: Team[] }>(`/workspaces/${workspaceId}/teams`, { method: 'GET' }, getToken, doRefresh),

  create: (workspaceId: string, name: string, description: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<Team>(
      `/workspaces/${workspaceId}/teams`,
      { method: 'POST', body: JSON.stringify({ name, description }) },
      getToken,
      doRefresh,
    ),

  get: (workspaceId: string, teamId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<GetTeamResponse>(`/workspaces/${workspaceId}/teams/${teamId}`, { method: 'GET' }, getToken, doRefresh),

  update: (
    workspaceId: string,
    teamId: string,
    updates: Partial<Pick<Team, 'name' | 'description'>>,
    getToken: GetToken,
    doRefresh: DoRefresh,
  ) =>
    authedJson<Team>(
      `/workspaces/${workspaceId}/teams/${teamId}`,
      { method: 'PUT', body: JSON.stringify(updates) },
      getToken,
      doRefresh,
    ),

  remove: (workspaceId: string, teamId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<void>(`/workspaces/${workspaceId}/teams/${teamId}`, { method: 'DELETE' }, getToken, doRefresh),

  addMember: (workspaceId: string, teamId: string, email: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<TeamMemberInfo>(
      `/workspaces/${workspaceId}/teams/${teamId}/members`,
      { method: 'POST', body: JSON.stringify({ email }) },
      getToken,
      doRefresh,
    ),

  removeMember: (workspaceId: string, teamId: string, userId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<void>(
      `/workspaces/${workspaceId}/teams/${teamId}/members/${userId}`,
      { method: 'DELETE' },
      getToken,
      doRefresh,
    ),
};
